var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "Pencil--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Pencil Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil--change-edit-modify-pencil-write-writing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#ffffff",
    d: "m3.1643014714285718 35.77059514285715 12.428901000000002 -3.242322s-1.5745768285714286 -3.8864357142857147 -4.3124845714285716 -6.619196914285714C8.542836685714287 23.17631502857143 4.644834514285715 21.6004383 4.644834514285715 21.6004383L1.3708665814285714 33.96585642857143c-0.27329203714285716 1.0322267142857144 0.76185282 2.0737384285714286 1.79343489 1.8047387142857145Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "m15.603389442857145 32.51341714285714 18.096385414285713 -17.364170314285715c3.0078094285714285 -2.886282042857143 2.775419142857143 -7.995605314285715 -0.5130625714285715 -11.271910414285715C29.975694000000004 0.6781843585714287 25.078387071428573 0.4583526985714286 22.247974199999998 3.3862925571428573L4.645099800000001 21.595742742857148s3.899408185714286 1.5722953714285715 6.639783085714287 4.302509828571429c2.7403749000000004 2.7303205714285714 4.318506557142857 6.615164571428571 4.318506557142857 6.615164571428571Z",
    clipRule: "evenodd",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.603389442857145 32.51341714285714 18.096385414285713 -17.364170314285715c3.0078094285714285 -2.886282042857143 2.775419142857143 -7.995605314285715 -0.5130625714285715 -11.271910414285715C29.975694000000004 0.6781843585714287 25.078387071428573 0.4583526985714286 22.247974199999998 3.3862925571428573L4.645099800000001 21.595742742857148s3.899408185714286 1.5722953714285715 6.639783085714287 4.302509828571429c2.7403749000000004 2.7303205714285714 4.318506557142857 6.615164571428571 4.318506557142857 6.615164571428571Z",
    clipRule: "evenodd",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3.1643014714285718 35.77059514285715 12.428901000000002 -3.242322s-1.5745768285714286 -3.8864357142857147 -4.3124845714285716 -6.619196914285714C8.542836685714287 23.17631502857143 4.644834514285715 21.6004383 4.644834514285715 21.6004383L1.3708665814285714 33.96585642857143c-0.27329203714285716 1.0322267142857144 0.76185282 2.0737384285714286 1.79343489 1.8047387142857145Z",
    strokeWidth: 2.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilStreamlineFlex);
export default __webpack_public_path__ + "static/media/Pencil--Streamline-Flex.7e6a43609f56b5170b7fd7cbd6d88841.svg";
export { ForwardRef as ReactComponent };